module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Spine List")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Manual List")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "loading": "true",
      "headers": _vm.headers,
      "items": _vm.parsedInstallations,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "50%"
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "50%"
          }
        }, [_vm._v(_vm._s(props.item.code))])])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "10px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "display": "block",
      "float": "left"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.fncAddManualInstallation
    }
  }, [_vm._v("Add Manual Installation")]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "display": "block",
      "float": "right"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.fncSaveManualList
    }
  }, [_vm._v("Save Manual List")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "loading": "true",
      "headers": _vm.headersManual,
      "items": _vm.parsedManualInstallations,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          attrs: {
            "width": "45%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Description",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (props.item.description),
            callback: function($$v) {
              _vm.$set(props.item, "description", $$v)
            },
            expression: "props.item.description"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "45%"
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Code",
            "single-line": "",
            "solo": ""
          },
          model: {
            value: (props.item.code),
            callback: function($$v) {
              _vm.$set(props.item, "code", $$v)
            },
            expression: "props.item.code"
          }
        })], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRemoveIndex(props.index)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncRunImport.apply(null, arguments)
      }
    }
  }, [_vm._v("Import From Spine")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_c('strong', [_vm._v(" ")])])])], 1)], 1)
},staticRenderFns: []}